/**
 * Domain utility functions for handling domain-specific logic
 */

export const getDomainExtension = (): string => {
  if (typeof window === 'undefined') return 'rs';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  return parts[parts.length - 1] || 'rs'; // Default to 'rs'
};

export const getBusinessUrl = (path: string = ''): string => {
  const extension = getDomainExtension();
  return `https://business.syndeo.${extension}${path}`;
};

export const getHelpUrl = (): string => {
  const extension = getDomainExtension();
  return `https://help.syndeo.${extension}/`;
};

export const getPortalUrl = (): string => {
  const extension = getDomainExtension();
  return `https://portal.syndeo.${extension}`;
};

export const getPaymentUrl = (bookingId: string): string => {
  const extension = getDomainExtension();
  return `https://payments.syndeo.${extension}/business/payment/${bookingId}/appointment`;
};

export const isMainDomain = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.startsWith('business.syndeo.');
};

export const isSameOrigin = (url: string): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return new URL(url).origin === window.location.origin;
  } catch (e) {
    return false;
  }
};
